import { useForm } from 'react-hook-form'
import { useState } from 'react'
import { Link } from 'react-router-dom'

import { ContactSubmitModal } from './SubmitModal'

import Toggle from '../assets/icons/toggle.svg'
import ToggleChecked from '../assets/icons/toggle-checked.svg'
import { postContactBrief } from 'apis/contact.ts'

export default function ContactInquiry() {
  const [modalOpen, setModalOpen] = useState(false)
  const openModal = () => {
    setModalOpen(true)
  }

  const [isSubmit, setIsSubmit] = useState(false)

  const {
    register,
    handleSubmit,
    formState: { isValid },
  } = useForm()

  const regEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i
  const regPhone = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/

  const onSubmit = async (data) => {
    const serviceString = `${data.newOrRenewal},${data.domain}`
    const budgetString = `${data.budgetMin}원~${data.budgetMax}원`
    let dataFile = data.file ? data.file[0] : null
    const postContactBriefResponse = await postContactBrief(
      {
        company: data.company,
        name: data.name,
        phone: data.phone,
        email: data.email,
        service: serviceString ? serviceString : '',
        message: data.message,
        reference: data.reference ? data.reference : '',
        budget: budgetString,
        date: data.date,
      },
      { file: dataFile }
    )
    if (postContactBriefResponse.error) {
      console.log(postContactBriefResponse.message)
      return
    } else {
      console.log(postContactBriefResponse)
    }
  }

  return (
    <div className='wrapper'>
      {/* background */}
      <div
        className='flex flex-col items-center justify-center w-full h-[500px] bg-no-repeat bg-cover bg-center'
        style={{
          backgroundImage: 'url(' + require('assets/images/contact-inquiry-background.png') + ')',
        }}
      >
        <div className='flex flex-col items-center justify-center gap-6'>
          <p className='text-body1-medium sm:text-h2-medium text-sk-assistive'>Contact</p>
          <p className='text-title2-bold sm:text-title1-bold text-sk-white'>간편문의</p>
        </div>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className='container flex flex-col items-center mx-auto py-60 sm:py-80 gap-80'>
          <div className='flex flex-col gap-64'>
            {/* 1. 기본정보 */}
            <div className='flex flex-col items-start justify-center gap-20'>
              <p className='text-center text-title3-bold text-sk-default'>1. 기본정보</p>
              <div className='flex flex-col sm:grid sm:grid-cols-2'>
                <div className='flex'>
                  <div className='flex items-center px-10 2xs:px-20 py-16 w-[100px] 2xs:min-w-150 md:min-w-200 bg-neutral-99 border-t-solid border-t-[1px] border-sk-border-default'>
                    <p className=' text-body1-semibold 2xs:text-h2-semibold text-sk-default'>
                      회사명
                    </p>
                    <p className='text-h2-medium text-sk-red'>*</p>
                  </div>
                  <input
                    {...register('company', { required: true })}
                    type='text'
                    className='outline-none px-10 md:px-20 py-16 items-center bg-sk-white border-t-solid border-t-[1px] border-sk-border-default w-200 2xs:w-[300px] sm:w-[175px] md:w-[300px] lg:w-[350px] 2xl:w-[440px] text-body1-medium sm:text-h2-medium text-sk-default placeholder:text-body2-medium 2xs:placeholder:text-body1-medium placeholder:text-sk-assistive'
                    placeholder='회사명을 입력해주세요'
                  />
                </div>
                <div className='flex'>
                  <div className='flex items-center px-10 2xs:px-20 py-16 w-[100px] 2xs:min-w-150 md:min-w-200 bg-neutral-99 border-t-solid border-t-[1px] border-sk-border-default text-h2-medium text-sk-default placeholder:text-body2-medium 2xs:placeholder:text-body1-medium placeholder:text-sk-assistive'>
                    <p className=' text-body1-semibold 2xs:text-h2-semibold text-sk-default'>
                      이름(직위)
                    </p>
                    <p className='text-h2-medium text-sk-red'>*</p>
                  </div>
                  <input
                    {...register('name', { required: true })}
                    type='text'
                    className='outline-none px-10 md:px-20 py-16 items-center bg-sk-white border-t-solid border-t-[1px] border-sk-border-default w-200 2xs:w-[300px] sm:w-[175px] md:w-[300px] lg:w-[350px] 2xl:w-[440px] text-body1-medium sm:text-h2-medium text-sk-default placeholder:text-body2-medium 2xs:placeholder:text-body1-medium placeholder:text-sk-assistive'
                    placeholder='이름을 입력해주세요'
                  />
                </div>
                <div className='flex'>
                  <div className='flex items-center px-10 2xs:px-20 py-16 w-[100px] 2xs:min-w-150 md:min-w-200 bg-neutral-99 border-y-solid border-y-[1px] border-sk-border-default '>
                    <p className=' text-body1-semibold 2xs:text-h2-semibold text-sk-default'>
                      전화번호
                    </p>
                    <p className='text-h2-medium text-sk-red'>*</p>
                  </div>
                  <input
                    {...register('phone', { required: true, pattern: regPhone })}
                    type='text'
                    className='outline-none px-10 md:px-20 py-16 items-center bg-sk-white border-y-solid border-y-[1px] border-sk-border-default w-200 2xs:w-[300px] sm:w-[175px] md:w-[300px] lg:w-[350px] 2xl:w-[440px] text-body1-medium sm:text-h2-medium text-sk-default placeholder:text-body2-medium 2xs:placeholder:text-body1-medium placeholder:text-sk-assistive'
                    placeholder='전화번호를 입력해주세요'
                  />
                </div>
                <div className='flex'>
                  <div className='flex items-center px-10 2xs:px-20 py-16 w-[100px] 2xs:min-w-150 md:min-w-200 bg-neutral-99 border-b-solid sm:border-y-solid border-b-[1px] sm:border-y-[1px] border-sk-border-default'>
                    <p className=' text-body1-semibold 2xs:text-h2-semibold text-sk-default'>
                      이메일
                    </p>
                    <p className='text-h2-medium text-sk-red'>*</p>
                  </div>
                  <input
                    {...register('email', { required: true, pattern: regEmail })}
                    type='text'
                    className='outline-none px-10 md:px-20 py-16 items-center bg-sk-white border-b-solid sm:border-y-solid border-b-[1px] sm:border-y-[1px] border-sk-border-default w-200 2xs:w-[300px] sm:w-[175px] md:w-[300px] lg:w-[350px] 2xl:w-[440px] text-body1-medium sm:text-h2-medium text-sk-default placeholder:text-body2-medium 2xs:placeholder:text-body1-medium placeholder:text-sk-assistive'
                    placeholder='이메일을 입력해주세요'
                  />
                </div>
              </div>
            </div>

            {/* 2. 서비스 */}
            <div className='flex flex-col items-start justify-center gap-20'>
              <p className='text-center text-title3-bold text-sk-default'>2. 서비스</p>
              <div className='flex flex-col'>
                {/* 신규/리뉴얼 */}
                <div className='flex'>
                  <div className='flex items-center px-10 2xs:px-20 py-16 w-[100px] 2xs:min-w-150 md:min-w-200 bg-neutral-99 border-t-solid border-t-[1px] border-sk-border-default'>
                    <p className=' text-body1-semibold 2xs:text-h2-semibold text-sk-default'>
                      신규/리뉴얼
                    </p>
                  </div>
                  <div className='px-10 2xs:px-20 py-16 items-center bg-sk-white border-t-solid border-t-[1px] border-sk-border-default w-[200px] 2xs:w-[300px] sm:w-[500px] md:w-[700px] lg:w-[900px] 2xl:min-w-[1080px] flex gap-28'>
                    <label className='relative flex items-center gap-10'>
                      <input
                        {...register('newOrRenewal')}
                        type='radio'
                        value='신규 제작'
                        label='신규 제작'
                        className='w-20 h-20 bg-center bg-no-repeat appearance-none peer'
                        style={{
                          backgroundImage: `url(${Toggle})`,
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition: 'center',
                        }}
                      />
                      <img
                        className='absolute left-0 invisible peer-checked:visible'
                        src={ToggleChecked}
                        alt=''
                      />
                      <p className='text-sk-sub text-body2-medium 2xs:text-body1-medium'>
                        신규 제작
                      </p>
                    </label>
                    <label className='relative flex items-center gap-10'>
                      <input
                        {...register('newOrRenewal')}
                        type='radio'
                        value='리뉴얼'
                        label='리뉴얼'
                        className='w-20 h-20 bg-center bg-no-repeat appearance-none peer'
                        style={{
                          backgroundImage: `url(${Toggle})`,
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition: 'center',
                        }}
                      />
                      <img
                        className='absolute left-0 invisible peer-checked:visible'
                        src={ToggleChecked}
                        alt=''
                      />
                      <p className='text-sk-sub text-body2-medium 2xs:text-body1-medium'>리뉴얼</p>
                    </label>
                  </div>
                </div>
                {/* 도메인 */}
                <div className='flex'>
                  <div className='flex items-center px-10 2xs:px-20 py-16 w-[100px] 2xs:min-w-150 md:min-w-200 bg-neutral-99 border-y-solid border-y-[1px] border-sk-border-default'>
                    <p className=' text-body1-semibold 2xs:text-h2-semibold text-sk-default'>
                      도메인
                    </p>
                  </div>
                  <div className='px-10 2xs:px-20 py-16 items-center bg-sk-white border-y-solid border-y-[1px] border-sk-border-default w-[200px] 2xs:w-[300px] sm:w-[500px] md:w-[700px] lg:w-[900px] 2xl:w-[1080px] grid grid-cols-2 sm:flex gap-18 gap-y-8 sm:gap-28'>
                    <label className='relative flex items-center gap-10'>
                      <input
                        {...register('domain')}
                        type='radio'
                        value='반응형 웹'
                        label='반응형 웹'
                        className='w-20 h-20 bg-center bg-no-repeat appearance-none peer'
                        style={{
                          backgroundImage: `url(${Toggle})`,
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition: 'center',
                        }}
                      />
                      <img
                        className='absolute left-0 invisible peer-checked:visible'
                        src={ToggleChecked}
                        alt=''
                      />
                      <p className='text-sk-sub text-body2-medium 2xs:text-body1-medium'>
                        반응형 웹
                      </p>
                    </label>
                    <label className='relative flex items-center gap-10'>
                      <input
                        {...register('domain')}
                        type='radio'
                        value='웹'
                        label='웹'
                        className='w-20 h-20 bg-center bg-no-repeat appearance-none peer'
                        style={{
                          backgroundImage: `url(${Toggle})`,
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition: 'center',
                        }}
                      />
                      <img
                        className='absolute left-0 invisible peer-checked:visible'
                        src={ToggleChecked}
                        alt=''
                      />
                      <p className='text-sk-sub text-body2-medium 2xs:text-body1-medium'>웹</p>
                    </label>
                    <label className='relative flex items-center gap-10'>
                      <input
                        {...register('domain')}
                        type='radio'
                        value='앱'
                        label='앱'
                        className='w-20 h-20 bg-center bg-no-repeat appearance-none peer'
                        style={{
                          backgroundImage: `url(${Toggle})`,
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition: 'center',
                        }}
                      />
                      <img
                        className='absolute left-0 invisible peer-checked:visible'
                        src={ToggleChecked}
                        alt=''
                      />
                      <p className='text-sk-sub text-body2-medium 2xs:text-body1-medium'>앱</p>
                    </label>
                    <label className='relative flex items-center gap-10'>
                      <input
                        {...register('domain')}
                        type='radio'
                        value='기타'
                        label='기타'
                        className='w-20 h-20 bg-center bg-no-repeat appearance-none peer'
                        style={{
                          backgroundImage: `url(${Toggle})`,
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition: 'center',
                        }}
                      />
                      <img
                        className='absolute left-0 invisible peer-checked:visible'
                        src={ToggleChecked}
                        alt=''
                      />
                      <p className='text-sk-sub text-body2-medium 2xs:text-body1-medium'>기타</p>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            {/* 3. 상세문의 내용 */}
            <div className='flex flex-col items-start justify-center gap-20'>
              <p className='text-center text-title3-bold text-sk-default'>3. 상세문의 내용</p>
              <div className='flex h-200'>
                <div className='flex items-start px-10 2xs:px-20 py-16 w-[100px] 2xs:min-w-150 md:min-w-200 bg-neutral-99 border-y-solid border-y-[1px] border-sk-border-default'>
                  <p className=' text-body1-semibold 2xs:text-h2-semibold text-sk-default'>
                    문의 내용
                  </p>
                  <p className='text-h2-medium text-sk-red'>*</p>
                </div>
                <textarea
                  {...register('message', { required: true })}
                  className='outline-none px-10 2xs:px-20 py-16 items-center bg-sk-white border-y-solid border-y-[1px] border-sk-border-default w-[200px] 2xs:w-[300px] sm:w-[500px] md:w-[700px] lg:w-[900px] 2xl:min-w-[1080px] resize-none text-body1-medium sm:text-h2-medium text-sk-default placeholder:text-body2-medium 2xs:placeholder:text-body1-medium placeholder:text-sk-assistive'
                  placeholder='문의 내용을 입력해주세요'
                />
              </div>
              <div className='flex flex-col sm:grid sm:grid-cols-2'>
                {/* 레퍼런스 url */}
                <div className='flex'>
                  <div className='flex items-center px-10 2xs:px-20 py-16 w-[100px] 2xs:min-w-150 md:min-w-200 bg-neutral-99 border-t-solid border-t-[1px] border-sk-border-default'>
                    <p className=' text-body1-semibold 2xs:text-h2-semibold text-sk-default'>
                      레퍼런스 url
                    </p>
                  </div>
                  <input
                    {...register('reference')}
                    type='text'
                    className='outline-none px-10 2xs:px-20 py-16 items-center bg-sk-white border-t-solid border-t-[1px] border-sk-border-default w-[200px] 2xs:w-[300px] lg:w-[350px] 2xl:min-w-[440px] text-body1-medium sm:text-h2-medium text-sk-default placeholder:text-body2-medium 2xs:placeholder:text-body1-medium placeholder:text-sk-assistive'
                    placeholder='url를 입력해주세요'
                  />
                </div>
                {/* 예산 */}
                <div className='flex'>
                  <div className='flex items-center md:px-20 px-[15px] py-16 w-[100px] 2xs:min-w-150 md:min-w-200 bg-neutral-99 border-t-solid border-t-[1px] border-sk-border-default text-h2-medium text-sk-default placeholder:text-body2-medium 2xs:placeholder:text-body1-medium placeholder:text-sk-assistive'>
                    <p className='text-body1-semibold md:text-h2-semibold text-sk-default'>
                      예산 <span className='max-2xs:hidden'>(최소~최대)</span>
                    </p>
                    <p className='text-h1-medium md:text-h2-medium text-sk-red'>*</p>
                  </div>
                  <div className='flex items-center justify-between px-12 2xs:px-20 py-16 border-t-solid border-t-[1px] border-sk-border-default w-[200px] 2xs:w-[300px] sm:w-[175px] md:w-[300px] lg:w-[350px] 2xl:min-w-[440px]'>
                    <div className='flex items-center gap-4 sm:gap-0 md:gap-12'>
                      <input
                        {...register('budgetMin', { required: true })}
                        type='text'
                        className='outline-none items-center bg-sk-white w-50 md:w-[70px] lg:w-[110px] text-body1-medium sm:text-h2-medium text-sk-default placeholder:text-body2-medium md:placeholder:text-body1-medium placeholder:text-sk-assistive'
                        placeholder='최소'
                      />
                      <p className='text-body2-medium md:text-body1-medium text-sk-default'>원</p>
                    </div>
                    <p className='text-body2-medium md:text-body1-medium text-sk-default'>~</p>
                    <div className='flex items-center gap-4 sm:gap-0 md:gap-12'>
                      <input
                        {...register('budgetMax', { required: true })}
                        type='text'
                        className='outline-none items-center bg-sk-white w-50 md:w-[70px] lg:w-[110px] text-body1-medium sm:text-h2-medium text-sk-default placeholder:text-body2-medium md:placeholder:text-body1-medium placeholder:text-sk-assistive'
                        placeholder='최대'
                      />
                      <p className='text-body2-medium md:text-body1-medium text-sk-default'>원</p>
                    </div>
                  </div>
                </div>
                {/* 참고자료 */}
                <div className='flex'>
                  <div className='flex items-center px-10 2xs:px-20 py-16 w-[100px] 2xs:min-w-150 md:min-w-200 bg-neutral-99 border-y-solid border-y-[1px] border-sk-border-default '>
                    <p className=' text-body1-semibold 2xs:text-h2-semibold text-sk-default'>
                      참고자료
                    </p>
                  </div>
                  <div className='px-10 2xs:px-20 py-10 border-y-solid border-y-[1px] border-sk-border-default w-[200px] 2xs:w-[300px] lg:w-[350px] 2xl:min-w-[440px] flex justify-start items-center'>
                    <label className='py-8 cursor-pointer px-36 md:px-48 button_black text-sk-white'>
                      업로드
                      <input
                        {...register('file')}
                        type='file'
                        className='hidden'
                        accept='.pdf, .jpg, .jpeg, .png'
                      />
                    </label>
                  </div>
                </div>
                <div className='flex'>
                  <div className='flex items-center px-10 2xs:px-20 py-16 w-[100px] 2xs:min-w-150 md:min-w-200 bg-neutral-99 border-b-solid sm:border-y-solid border-b-[1px] sm:border-y-[1px] border-sk-border-default'>
                    <p className=' text-body1-semibold 2xs:text-h2-semibold text-sk-default'>
                      희망날짜
                    </p>
                    <p className='text-h2-medium text-sk-red'>*</p>
                  </div>
                  <input
                    {...register('date', { required: true })}
                    type='text'
                    className='outline-none px-10 2xs:px-20 py-16 items-center bg-sk-white border-b-solid sm:border-y-solid border-b-[1px] sm:border-y-[1px] border-sk-border-default w-[200px] 2xs:w-[300px] sm:w-[175px] md:w-[300px]  lg:w-[350px] 2xl:min-w-[440px] text-body1-medium sm:text-h2-medium text-sk-default placeholder:text-body2-medium 2xs:placeholder:text-body1-medium placeholder:text-sk-assistive'
                    placeholder='예시 ) 2025년 3월 2일/ 2025년 3월 말 / 최대한 빨리 '
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='relative flex flex-col items-center'>
            {!isValid && (
              <p className='absolute bottom-[78px] text-body1-medium text-sk-red'>
                필수 항목을 모두 입력해주세요
              </p>
            )}
            <div className='flex items-center justify-center gap-32'>
              <Link
                to='/'
                type='button'
                className='py-12 px-36 2xs:px-48 2xs:py-16 button_white2 text-h2-medium 2xs:text-h1-medium text-sk-default'
              >
                취소하기
              </Link>
              <button
                disabled={!isValid}
                type='submit'
                className='py-12 px-36 2xs:px-48 2xs:py-16 button_black text-sk-white text-h2-medium 2xs:text-h1-medium'
                onClick={() => {
                  setIsSubmit((prev) => !prev)
                  openModal()
                }}
              >
                문의하기
              </button>
              {modalOpen && <ContactSubmitModal setModalOpen={setModalOpen} isSubmit={isSubmit} />}
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}
